import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { viewports } from '@telus-uds/system-constants';
import { ViewportContext } from './useViewport';
import useViewportListener from './useViewportListener';
/**
 * Provides an up-to-date viewport value from system-constants, available via the `useViewport` hook
 */

import { jsx as _jsx } from "react/jsx-runtime";

const ViewportProvider = _ref => {
  let {
    children
  } = _ref;
  // Default to the smallest viewport for mobile-first SSR. On client side, this is updated
  // by useViewportListener in a layout effect before anything is shown to the user.
  const [viewport, setViewport] = useState(viewports.keys[0]);
  useViewportListener(setViewport);
  return /*#__PURE__*/_jsx(ViewportContext.Provider, {
    value: viewport,
    children: children
  });
};

ViewportProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default ViewportProvider;